module.exports = __webpack_public_path__ + "img/code.7045e526.png";